import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { store } from 'store/index';
import API from "api.js";
import { setToken, setUser, setLogo, setSub, setLoader } from 'action/index.js';
import { getSubdomain, toPartnerHost, isWhiteLabel } from 'utils/whiteLabel';


const mapStateToProps = (state) => {
	return {
		token: state.token
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setToken: (tok) => dispatch(setToken(tok)),
		setUser: (user) => dispatch(setUser(user)),
		setSub: (sub) => dispatch(setSub(sub)),
		setLogo: (sub) => dispatch(setLogo(sub))
	};
};

const CheckPost = (props) => {
	const location = useLocation();
	const navigate = useNavigate();

	console.log("inside check post");


	useEffect(() => {
		const query = new URLSearchParams(location.search);
		const cust = query.get('cust');

		if (!cust) {
			console.error('No cust parameter found');
			return;
		}

		console.log('Calling API with cust:', cust);
		store.dispatch(setLoader(true));

		// The backend needs the partner subdomain to resolve the institute, and
		// enforces it: a token from another institute comes back 402
		// "Unauthorized Institute User". This is the cross-tenant guard — without
		// it the endpoint skips the check entirely. Core is served on the partner
		// host itself, so derive it locally; omitted off a partner subdomain so
		// LA installs are unchanged.
		console.log("white",isWhiteLabel())
		const sub = isWhiteLabel() ? getSubdomain() : null;
		const subParam = sub ? `&subdomain=${encodeURIComponent(sub)}` : '';

		API({
			method: 'GET',
			url: `/loginDataWithToken?cust=${cust}${subParam}`,
		}).then((res) => {
			props.setToken(res.data.access_token);
			props.setUser(res.data.user);
			let sub = (res.data.user.active_subscription.length === 0) ? false : true;
			props.setSub(sub);

			store.dispatch(setLoader(false));
			const currentState = store.getState();
			if (currentState.logo === '/images/logol.png') {
				console.log('Clearing old persisted logo');
				store.dispatch(setLogo(''));
			}
			navigate('/admin/dashboard');
		}).catch(err => {
			console.error('API Error:', err);
			store.dispatch(setLoader(false));
			// Surface the backend's reason (e.g. the 402 cross-tenant rejection)
			// instead of a generic message, then leave the blank handoff screen
			// for the partner's own login rather than stranding the user on it.
			const reason = err?.response?.data?.message;
			alert(reason || "Unable to process your request. Please try again from PTE academic dashboard.");
			window.location.href = `${toPartnerHost(import.meta.env.VITE_LA_URL)}/auth/login`;
		});
	}, [location.search, navigate, props]);

	return "";
}
export default connect(mapStateToProps, mapDispatchToProps)(CheckPost);